import { render, staticRenderFns } from "./SubUnitDeleteButton.vue?vue&type=template&id=4a90f6ba&scoped=true&"
import script from "./SubUnitDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./SubUnitDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./SubUnitDeleteButton.vue?vue&type=style&index=0&id=4a90f6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a90f6ba",
  null
  
)

export default component.exports